// extracted by extract-css-chunks-webpack-plugin
module.exports = {"flow":"_15AyzF","withAvatar":"_3YIsGf","absolute":"_3hSbQK"};